export default __webpack_public_path__ + "static/queen-31d77a702a625dc8c35b8636e3dbba5b.png";